export const delay = ms => {
  let timer;
  return Object.assign(new Promise(res => {
    timer = setTimeout(res, ms);
  }), {
    reset: () => {
      clearTimeout(timer);
    }
  });
};